module.exports = __webpack_public_path__ + "static/media/tkg_flex.8b8dceb8.png";